(() =>
{
  const DOMAIN = 'checkout.frolov.fr';

  const clearCart = () =>
  {
    const url = new URL(window.location.href);

    if (url.searchParams.get('clear_cart') === '1')
    {
      url.searchParams.delete('clear_cart');

      fetch('/cart/clear.js', {method: 'POST'}).then(() => window.location.href = url.toString());
    }
  }

  const sha256 = async (message) =>
  {
    const msgBuffer = new TextEncoder().encode(message);
    const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);
    const hashArray = Array.from(new Uint8Array(hashBuffer));

    return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
  }

  const submit = async (e) =>
  {
    e.preventDefault();

    const result = await fetch('/cart.json');

    if (result.status === 200)
    {
      const cart_params = await result.text();

      let domain = 'frolov.ua';

      const result_extra = await fetch('/?section_id=cart-json');

      if (result_extra.status === 200)
      {
        const html = new DOMParser().parseFromString(await result_extra.text(), 'text/html');
        const cart_products = JSON.parse(html.querySelector('.shopify-section').innerText);

        let custom_domain = true;

        for (const product_id of Object.keys(cart_products))
        {
          let flag = false;

          for (const collection_id of window.checkout_collections_ids)
          {
            if (cart_products[product_id].collection_id.indexOf(collection_id) !== -1)
            {
              flag = true;
            }
          }

          if (!flag)
          {
            custom_domain = false;
            break;
          }
        }

        !custom_domain || (domain = window.location.host);
      }

      window.location.href = `https://${DOMAIN}/${document.documentElement.lang}/checkout?domain=${domain}&cart_params=${encodeURIComponent(cart_params)}&sign=${await sha256(domain + cart_params + '_checkout')}`;
    }
  }

  const init = () =>
  {
    document.querySelectorAll('form[action$="/cart"], form[action$="/checkout"]').forEach((item) =>
    {
      item.removeEventListener('submit', submit);
      item.addEventListener('submit', submit);
    });
  }

  clearCart();

  setInterval(init, 1000);
  init();
})();